import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/storageAreaInfo/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 初始化区位树
 */
export function FetchStorageAreaTree() {
    return request({
        url: "/base/storageAreaInfo/getStorageAreaInfoTree",
        method: "post",
    });
}

/**
 * 冷库下拉
 * @param {*} data
 */
export function FindStorageAll() {
  return request({
      url: "/base/storage/findStorageAll",
      method: "get",
  });
}
/**
 * 保存
 * @param {*} data
 */
export function SaveStorageAreaInfo(data) {
  return request({
      url: "/base/storageAreaInfo/saveStorageAreaInfo",
      method: "post",
      headers: {type: "json"},
      data
  });
}
/**
 * 删除
 * @param {*} data
 */
export function DeleteStorageAreaInfoByIds(data) {
  return request({
      url: "/base/storageAreaInfo/deleteStorageAreaInfoByIds",
      method: "post",
      data
  });
}
/**
 * 查询单条
 * @param {*} data
 */
export function FindStorageAreaInfoById(data) {
  return request({
      url: "/base/storageAreaInfo/findStorageAreaInfoById",
      method: "post",
      data
  });
}

/**
 * 库区下拉框
 * @param {*} data
 */
export function FindStorageAreaAllByStorageId(data) {
  return request({
      url: "/base/storageAreaInfo/findStorageAreaAllByStorageId",
      method: "post",
      data
  });
}